export default __webpack_public_path__ + "static/media/acct-analytics.053d0fb7.png";